import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./usersView.styl";
const template = require("./usersView.vue");

@Component({
  template: template
})
export class UsersViewComponent extends Vue {

}

Vue.component("cmUsersView", UsersViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/usersView/usersView.ts